import { css } from 'styled-components';

export const brandFonts = {
  primary: () => {
    return css`
      font-family: 'Quicksand', 'sans-serif';
      font-weight: 500;
    `;
  },
  secondary: () => {
    return css`
      font-family: 'filosofia', 'serif';
      font-weight: 400;
    `;
  },
  tertiary: () => {
    return css`
      font-family: 'Gustolle', 'Brush Script MT', 'cursive';
      font-weight: 400;
    `;
  },
};
